import styled from 'styled-components';
import {dFlex, mobileMedia} from '../../globalVariables/GlobalVariables';

export const card = styled.div<{$bordered?: boolean}>`
    ${dFlex};
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 392px;
    overflow: hidden;
    background: ${p => p.$bordered ? 'var(--TA-color-bg-base)' : 'transparent'};
    border: ${p => p.$bordered ? '1px solid var(--TA-color-border-subtle)' : 'none'};
    border-radius: ${p => p.$bordered ? 'var(--border-radius-border-radius-2xl, 24px)' : '0'};
    ${mobileMedia} {
        height: auto;
        min-height: 360px;
        gap: var(--space-xl);
        padding: var(--space-xl) 0;
    }
`;

export const content = styled.div`
    ${dFlex};
    flex-direction: column;
    align-items: center;
    gap: var(--space-md);
    width: 461px;
    max-width: 100%;
    padding: var(--space-xl) var(--space-lg) 0;
    text-align: center;
    ${mobileMedia} {
        padding: 0 var(--space-md);
    }
`;

export const image = styled.img`
    width: 200px;
    height: 200px;
    object-fit: contain;
    ${mobileMedia} {
        width: 160px;
        height: 160px;
    }
`;

export const title = styled.h3`
    margin: 0;
    font-family: Assistant, sans-serif;
    font-weight: 700;
    font-size: var(--font-size-body);
    line-height: 1.4;
    color: var(--TA-color-text-default);
`;

export const description = styled.p`
    margin: 0;
    font-family: Assistant, sans-serif;
    font-weight: 400;
    font-size: var(--font-size-body);
    line-height: 1.4;
    color: var(--TA-color-text-default);
    white-space: pre-line;
`;

export const actions = styled.div`
    ${dFlex};
    align-items: center;
    justify-content: center;
    gap: var(--space-md);
    width: 100%;
    height: 66px;
    padding: 10px;
    box-sizing: border-box;
    background: var(--TA-color-bg-base);
    overflow: hidden;
    ${mobileMedia} {
        height: auto;
        padding: 0 var(--space-md);
    }
`;
